import { normalizarTexto } from '../texto/normalizar.js';
/** Sem hora, o estudo herda o mesmo padrão de `proximaVisita.ts`. Esta
 *  constante é local a este interpretador e não é compartilhada com
 *  `interpretarProximaVisita`. */
const HORA_PADRAO = 9;
const NOMES_DOS_DIAS = [
    'Domingo',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
];
// Chaves sem acento: é assim que o texto chega depois de normalizado, e o
// teclado do iPhone no bolso raramente acentua.
const DIAS_DA_SEMANA = {
    domingo: 0,
    segunda: 1,
    terca: 2,
    quarta: 3,
    quinta: 4,
    sexta: 5,
    sabado: 6,
};
const PADRAO = /^(domingo|segunda|terca|quarta|quinta|sexta|sabado)(-feira)?(?:\s+(?:as\s+)?(\d{1,2})(?:[h:](\d{2}))?h?)?$/;
function descrever(dia, hora, minuto) {
    const relogio = minuto === 0 ? `${hora}h` : `${hora}h${String(minuto).padStart(2, '0')}`;
    return `${NOMES_DOS_DIAS[dia]}, às ${relogio}`;
}
/**
 * Interpreta a frequência que o publicador digita no formulário de estudo:
 * "sábado 10h", "terça 19:30", "domingo". Devolve `null` quando não tem
 * certeza — inclusive para o texto vazio, que é o "sem horário fixo" que a
 * entidade guarda com nulos.
 */
export function interpretarFrequencia(texto) {
    const limpo = normalizarTexto(texto);
    if (limpo === '')
        return null;
    const casou = PADRAO.exec(limpo);
    if (casou === null)
        return null;
    const dia = DIAS_DA_SEMANA[casou[1]];
    if (dia === undefined)
        return null;
    // "-feira" só existe de segunda a sexta; "sábado-feira" e
    // "domingo-feira" são enganos, não frequências válidas.
    if (casou[2] !== undefined && (dia === 0 || dia === 6))
        return null;
    const hora = casou[3] === undefined ? HORA_PADRAO : Number(casou[3]);
    const minuto = casou[4] === undefined ? 0 : Number(casou[4]);
    if (hora > 23 || minuto > 59)
        return null;
    return {
        dia_da_semana: dia,
        hora: `${String(hora).padStart(2, '0')}:${String(minuto).padStart(2, '0')}`,
        descricao: descrever(dia, hora, minuto),
    };
}
//# sourceMappingURL=frequencia.js.map